import { RmsColors } from './shared/constants/rms-colors';
import { DateTime } from 'luxon';


export const CONFIG = {
  defaultTenantId: 1,
  nonHealthCareTenantId: 3,
  apiUrl: '/api',
  pillsColorList: {
    companies: [
      '#203D02',
      '#5DB005',
      '#179A01',
      '#0F6500',
      '#9DF244',
      '#1DCA00',
      '#3F7A02',
      '#6DD202',
      '#6BA82A',
      '#90DE3D'
    ],
    indications: [
      '#690000',
      '#F07760',
      '#CC0A0A',
      '#80132C',
      '#FF621F',
      '#E41515',
      '#BB0F37',
      '#FF0000',
      '#B50909',
      '#F71147'
    ],
    products: [
      '#001C49',
      '#7BB9FF',
      '#0C4DB4',
      '#1A415D',
      '#55B3F7',
      '#1D6EA9',
      '#0B4671',
      '#07C6D6',
      '#003281',
      '#0E6BFF'
    ],
    events: '#B99520',
    unclassified: '#63676D'
  },
  wsURL: '/ws/websocket/websocket',
  metadataPath: '/metadata',
  imagesUrl: 'assets/images/',
  i18nPath: 'assets/i18n/',
  duoScriptUrl: 'https://api.duosecurity.com/frame/hosted/Duo-Web-v2.min.js',
  blackbirdServiceRequestUrl: 'https://pool-clutch-e36.notion.site/Blackbird-Swiftbridge-Service-Request-3608a376f0a180ea929ace7e06fcb173',
  monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  dateFormat: 'yyyy-MM-dd',
  rangeDateFormat: 'mm/dd/yyyy',
  shortDateFormat: 'MM/dd/yyyy',
  dateTimeFormat: "MM-dd-yyyy 'at' hh:mma",
  dateTimeFormatAlternative: 'MM/dd/yyyy hh:mma',
  dateTimeFormatProfile: 'MM/dd/yyyy - hh:mma',
  dateTimeFormatShort: "MM/dd/yyyy, hh:mma",
  dateTimeFormatSeparate: "MM/dd/yyyy 'at' hh:mma",
  dateTimeFormatWithoutHour: 'MM/dd/yyyy',
  dateTimeDetailedFormat: 'MM/dd/yyyy hh:mm:ssa',
  restrictionDateFormat: 'MM/dd/yy',
  restrictionDateTimeFormat: 'MM/dd/yy, h:mm a',
  dateTimeBasicFormat: 'yyyy-MM-dd HH:mm',
  dateTimeServerFormatFullMillis: 'yyyy-MM-dd HH:mm:ss.SSS',
  dateTimeServerFormat: 'yyyy-MM-dd HH:mm:ss.S',
  dateMMMDD: 'MM dd',
  dateWeekDay: 'dddd, LL',
  defaultExchangeName: 'NASDAQ',
  timeOnly: 'hh:mma',
  basicTimeOnly: 'HH:mm',
  verboseDateFormat: 'MMMM dd, yyyy',
  formatEST: 'America/New_York',
  timezoneUTC: 'Etc/UTC',
  passwordPattern: '(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[0-9]).{8,}',
  basicStringPattern: '[a-zA-Z ]+',
  financialRawNumberPattern: '^\\d{0,18}(\\.\\d{0,8})?$',
  financialNumberPattern: '^-?\\d{0,18}(\\.\\d{0,8})?$',
  phoneNumberUSAPattern: '^(1\\s?)?((\\([0-9]{3}\\))|[0-9]{3})[\\s\\-]?[\\0-9]{3}[\\s\\-]?[0-9]{4}$',
  urlPattern: '/^(https?:\\/\\/)?([\\da-z\\.-]+)\\.([a-z\\.]{2,6})([\\/\\w \\.-]*)*\\/?$/',
  httpAndHttpsPattern: '^(http[s]:\/\/www\.|http:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$',
  absoluteUrlPatter: '^(?:https?:)?//',
  absoluteImageSrc: '(src=")(https?:\/\/)\/?([^"]+\.(jpe?g|png|gif|bmp|svg))"',
  /*
   * Changing this breaks the analytics identity seed in src/index.html, which hard-codes
   * 'rms-loggedUser' because it runs before Angular exists and cannot import this constant.
   * See src/app/core/services/analytics/CLAUDE.md.
   */
  storagePrefix: 'rms',
  defaultLang: 'en',
  defaultProfileImage: 'assets/images/default.jpg',
  authErrorCode: 'BUS_0001',
  twoFactorAuthErrorCode: 'BUS_0051',
  passwordExpiredErrorCode: 'BUS_0058',
  wsRetryTimeOut: 120000, // time in milliseconds equivalent to 2 minutes
  timerRefreshHeadlines: 60,
  timerRefreshStandard: 60,
  timerRefreshCrm: 60,
  tooltipOpenDelay: 200,
  headlinesEntriesPerRequest: 50,
  fileUploadAllowedExtensions:
    'text/plain,' +
    'application/pdf,' +
    'application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,' +
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,' +
    'application/vnd.ms-powerpoint,' +
    'application/vnd.openxmlformats-officedocument.presentationml.slideshow,' +
    'application/vnd.openxmlformats-officedocument.presentationml.presentation,' +
    '.jpg, .png, .tiff',
  defaultCurrency: {
    code: 'USD',
    name: 'United States Dollar'
  },
  momentShortFormat: {
    relativeTime: {
      future: 'in %s',
      past: '%s',
      s: '1s',
      ss: '%ss',
      m: '1m',
      mm: '%dm',
      h: '1h',
      hh: '%dh',
      d: '1d',
      dd: '%dd',
      M: '1m',
      MM: '%dm',
      y: '1y',
      yy: '%dY'
    }
  },
  oAuth: {
    regular: {
      grantType: 'password',
      clientId: '',
      clientSecret: '',
      username: '',
      password: ''
    },
    twoFactor: {
      grantType: 'twoFactor',
      appName: 'duo',
      username: '',
      password: '',
      secretCode: ''
    },
    refreshToken: {
      grantType: 'refresh_token'
    },
  },
  select: {
    basic: {
      highlight: false,
      create: false,
      persist: true,
      plugins: ['dropdown_direction'],
      dropdownDirection: 'auto',
      labelField: 'name',
      valueField: 'id',
      searchField: ['name'],
      maxItems: 1
    },
    multiple: {
      highlight: false,
      plugins: ['dropdown_direction', 'remove_button'],
      dropdownDirection: 'auto',
      labelField: 'name',
      valueField: 'id',
      searchField: ['name'],
      maxItems: 100
    }
  },
  toggleSwitch: {
    activeColor: RmsColors.RMS_TEAL_COLOR,
    bgColor: RmsColors.GREY_ASH,
    size: 'small'
  },
  uploadSettings: {
    allowedTypes: ['image/png', 'image/jpg', 'image/jpeg', 'image/gif'],
    maxFileSize: 20000000
  },
  /**
   * Deck Comparisons self service (RA-2251): how often the modal re-checks an in-flight upload/comparison
   * request, and how long it keeps watching before giving up and removing the pinned row.
   *
   * Deliberately shorter than the backend's own staleness TTLs (upload 10 min, comparison 6 h). Give-up means
   * "stop watching and stop occupying the screen"; stale means "this is almost certainly never arriving". A
   * request the client gave up on is still PENDING server-side and its row is reconstructed on the next modal
   * open, which is correct — the deck may genuinely still land.
   */
  slideDeckRequest: {
    /** How often to re-check an in-flight upload. Uploads resolve in roughly 5–20s. */
    deckPollMs: 2000,
    /**
     * How often the company-scoped upload watch re-checks while **nothing** is in flight. The fast
     * {@link deckPollMs} cadence only buys anything when there is a row on screen changing; an open modal on a
     * quiet company would otherwise issue ~30 requests a minute forever. See `SlideDeckRequestStatusService`.
     */
    deckIdlePollMs: 20000,
    /** How long to watch an upload before removing its row without inventing an outcome. */
    deckGiveUpMs: 120000,
    /** How often to re-check an in-flight comparison. Generation runs for minutes. */
    comparisonPollMs: 15000,
    /** How often the company-scoped comparison watch re-checks while nothing is in flight; see {@link deckIdlePollMs}. */
    comparisonIdlePollMs: 60000,
    /** How long to watch a comparison before removing its row; TARA's email is the durable notification. */
    comparisonGiveUpMs: 1800000
  },
  defaultGetParams: {
    page: 0,
    pagesize: 10,
    direction: 'ASC'
  },
  pagination: {
    allowedRanges: [{ range: 10 }, { range: 20 }, { range: 30 }, { range: 40 }, { range: 50 }, { range: 75 }, { range: 100 }],
    maxPaginationItems: 3,
    directionLinks: true,
    boundaryLinks: false,
    ellipses: true,
    maxElasticSearchPageSize: 10000,
    maxNotesPageSize: 5000,
    rotate: true,
    size: '',
    singleLargePage: 200,
    singleLargerPage: 1000
  },
  alertOptions: {
    manualAlertOptions: [
      { name:  'Every Week', value: '1W' },
      { name:  'Every 2 Weeks', value: '2W' },
      { name:  'Every Month', value: '1' },
      { name:  'Every 3 Months', value: '3' },
      { name:  'Every 6 Months', value: '6' },
      { name:  'Every Year', value: '12' },
      { name:  'Every 2 Years', value: '24' },
    ],
    automaticAlertOptions: [
      { name:  'Disabled', value: '0' },
      { name:  '1M', value: '1' },
      { name:  '3M', value: '3' },
      { name:  '6M', value: '6' },
      { name:  '1Y', value: '12' },
      { name:  '2Y', value: '24' },
    ]
  },
  blackListHeadlines: ['AAP Rolling News Bulletin', 'FTSE Selected Stocks', 'Dow Jones Selected Stocks', 'NASDAQ Selected Stocks'],
  mobileWindowWidth: 1201,
  phoneWindowWidth: 768,
  defaultUserAttributes: {
    jobTitle: undefined,
    phoneNumber: undefined,
    language: undefined,
    isLeadExpert: undefined,
    maxAuthSessions: undefined,
    displayOverviewPage: 'false',
    hideNonOverviewNotes: 'false',
    displayResultNewWindow: 'false',
    expandNotesCompanyPage: 'false',
    deckComparisonNotificationEnable: 'false',
    deckComparisonNotificationScope: 'FOLLOWING',
    deckComparisonNotificationCadence: 'DAILY'
  },
  enableServerEmailLogging: false,
  viewAllPageLabel: 'ALL'
};
